import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { WebServiceResponse } from "src/app/interfaces/helpTarget";
import { LogClass, Logger } from "src/app/logger";
import {
  AbstractUserService,
  EntityId,
  IRoleAdmin,
  IRoleEdit,
  IUser,
  IUserLanguage,
  UserId
} from "../../interfaces";

@LogClass()
@Injectable({
  providedIn: "root"
})
export class SpUserService implements AbstractUserService {
  private logger: Logger;

  constructor(private http: HttpClient) {
    this.logger.debug("ctor");
  }
  public saveRoles(roles: IRoleAdmin[]): Observable<boolean> {
    const url = "/api/User/Roles";
    return this.http
      .post<WebServiceResponse<boolean>>(url, roles, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("SaveRoles"),
        map((res) => res.data)
      );
  }
  public getRoles(): Observable<IRoleAdmin[]> {
    const url = "/api/User/Roles";
    return this.http
      .get<WebServiceResponse<IRoleAdmin[]>>(url, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("getRoles"),
        map((res) => res.data)
      );
  }

  public saveUserRoles(
    userId: EntityId,
    roles: IRoleEdit[]
  ): Observable<boolean> {
    const url = `/api/User/Roles/${userId}`;
    return this.http
      .post<WebServiceResponse<boolean>>(url, roles, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("SaveUserRoles"),
        map((res) => res.data)
      );
  }
  public getUserRole(userId: EntityId): Observable<IRoleEdit[]> {
    const url = `/api/User/Roles/${userId}`;
    return this.http
      .get<WebServiceResponse<IRoleEdit[]>>(url, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("getUserRole"),
        map((res) => res.data)
      );
  }
  public getLanguages(): Observable<IUserLanguage> {
    const url = "/api/User/Languages";
    return this.http
      .get<WebServiceResponse<IUserLanguage>>(url, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("getLanguages"),
        map((res) => res.data)
      );
  }
  public setPreferredLanguage(lang: string): Observable<boolean> {
    const url = "/api/User/Preferred?preferredLanguage=" + lang;
    return this.http
      .post<WebServiceResponse<boolean>>(url, {
        responseType: "json",
        body: null
      })
      .pipe(
        this.logger.observableOperator("setPreferredLanguage"),
        map((res) => res.data)
      );
  }

  public getCurrentUser(): Observable<IUser> {
    const url = "/api/User";
    return this.http
      .get<WebServiceResponse<IUser>>(url, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("getUser"),
        map((res) => res.data)
      );
  }

  public getUser(userId: UserId): Observable<IUser> {
    const url = `/api/Users/${userId}`;
    return this.http
      .get<WebServiceResponse<IUser>>(url, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("getUser"),
        map((res) => res.data)
      );
  }

  public getAllUsers(): Observable<IUser[]> {
    const url = `/api/Users/`;
    return this.http
      .get<WebServiceResponse<IUser[]>>(url, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("getAllUser"),
        map((res) => res.data)
      );
  }

  public getUsers(logins: string[]): Observable<IUser[]> {
    const url = "/api/User";
    return this.http
      .post<WebServiceResponse<IUser[]>>(
        url,
        {
          logins: logins
        },
        {
          responseType: "json"
        }
      )
      .pipe(
        this.logger.observableOperator("getUsers"),
        map((res) => res.data)
      );
  }
}
